module.exports = __webpack_public_path__ + "static/media/card.c3ea8090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/new-haven/card.jpg
// module id = 866
// module chunks = 27